import React, { Component } from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import { fireAuth, fireSignOut, fireSignIn } from './helpers/fireHelper';

import About from './About';
import TermsAndConditions from './TermsAndConditions';
import PrivacyPolicy from './PrivacyPolicy';
import Create from './Create';
import Run from './Run';
import Account from './Account';
// import Footer from './Footer';
// import SearchBox from './SearchBox';
// import AcceptModal from './AcceptModal';
import PublicEnvelopes from './PublicEnvelopes';
// import UserEnvelopes from './UserEnvelopes';
import Host from './Host';
import _Embed from './_Embed';
import NavBar from './_NavBar';
// import Gallery from './_Gallery';
import MyEnvelopes from './_MyEnvelopes';
import Edit from './_Edit';

// import Signup from './_Signup';
// import Login  from './_Login';

import SignUpModal from './_SignUpModal';
import LoginModal from './_LoginModal';

import * as firebase from 'firebase';

// function GalleryRoute ({component: Component, authed, ...rest}) {
//   return (
//     <Route
//       {...rest}
//       render={(props) => authed === true
//         ? <Component user={rest.user} {...props} />
//         : <div>Loading ...</div>
//       }
//     />
//   )
// }

class App extends Component {
  constructor(props) {
    super(props)
    this.state = {
      user: null
    }
  }
  componentDidMount() {
    this.removeListener = fireAuth.onAuthStateChanged(user => {
      const role = localStorage.getItem("role"),
            industry = localStorage.getItem("industry");
      if (user && role) {
        firebase.database().ref().child('/users/' + user.uid)
          .update({ role })
          .then(res  => { localStorage.removeItem("role") })
          .catch(err => { localStorage.removeItem("role") })
        }

      if (user && industry) {
        firebase.database().ref().child('/users/' + user.uid)
          .update({ industry })
          .then(res  => { localStorage.removeItem("industry") })
          .catch(err => { localStorage.removeItem("industry") })
        }

      // if (localStorage.getItem("role")) { console.log('JEEJ'); }



      if (user) localStorage.setItem("hasLoggedIn", "true")
      this.setState({ user })
    })
    fireAuth.getRedirectResult().catch(error => { console.warn( error ) } ); // Callback for SignIn
  }
  componentWillUnmount () {
    this.removeListener()
  }

  render() {
    return (
      <Router>
        <Switch>

          {/* <Route path="/editt/" component={Edit}/> */}
          <Route path="/host/:key" component={Host}/>
          <Route path="/embed/:key" component={_Embed}/>
          <Route path="/testembed/:key"  component={_Embed}/>
          <Route
            render={(props) => <Routes {...props} user={this.state.user} />}
          />
        </Switch>
      </Router>
    )
  }
}

class Routes extends Component {
  constructor(props) {
    super(props)
    this.state = {
      searchString: '',
      activeModal: ''
      // user: null,
    }
  }

  // componentDidMount() {
  //   this.removeListener = fireAuth.onAuthStateChanged(user => {
  //     user ? this.setState({ user: user}) : this.setState({ user: null }) })
  //   fireAuth.getRedirectResult().catch(error => { console.warn(error) } ); // Callback for SignIn
  // }

  handleOpenModal   = () => { this.setState({ showModal: true });  }
  handleCloseModal  = () => { this.setState({ showModal: false }); }
  handleSearch = (query) => { this.setState({ searchString:query});}
  clearSearchString = () => { this.setState({ searchString: '' }); }
  signIn = (role, industry) => {
    console.log('SIGING IN WITH GOOGLE', role, industry)
    fireSignIn(role, industry);
  } // Callback in fireAuth.getRedirectResult() call
  signOut = () => { fireSignOut().then(err => { if (err !== "success") { console.warn(err) }}) }

  // componentWillUnmount () {
  //   this.removeListener()
  // }

  logOut = () => { this.signOut(); }
  logIn  = () => { this.setState({ activeModal: "login" });  }
  signUp = () => { this.setState({ activeModal: "signup" }); }
  signUpUser = (email, password, role, industry) => {
    firebase.auth().createUserWithEmailAndPassword(email, password)
      .then(res => {
        firebase.database().ref().child('/users/' + firebase.auth().currentUser.uid)
          .update({ role, industry })
          // .then(res => console.log('SUCCES', res))
          .catch(err => console.error('ERROR', err))
      })
      .catch(function(error) {
        // Handle Errors here.
        var errorCode = error.code;
        var errorMessage = error.message;
        alert('Sign up failed. \nMessage: ' + errorMessage + '\nCode: ' + errorCode)
      });
    // console.log('SIGN UP WITH EMAIL AND PW:', email, password);
    // console.log('NOW REALLYE');
  }
  signInUser = (email, password) => {
    firebase.auth().signInWithEmailAndPassword(email, password)
      .then(res => {
        console.log('SUCCESSFUL LOGIN', res)
      })
      .catch(function(error) {
        // Handle Errors here.
        var errorCode = error.code;
        var errorMessage = error.message;
        alert('Log in failed. \nMessage: ' + errorMessage + '\nCode: ' + errorCode)
        // ...
    });
  }

  closeModal = (str) => {
    if (this.state.activeModal === str) {
      this.setState({ activeModal: "" });
    }
  }



  render() {

    // const LogInorOut = this.props.user ?
    //   <li><a onClick={this.signOut}>Log Out</a></li> :
    //   <li><a onClick={this.signIn} >Log In</a></li>;

    return (
      <Router>
      <div>
        <SignUpModal
          switchToLogin={() => { this.setState({ activeModal: 'login' }) }}
          signUpWithGoogle={this.signIn}
          signUpUser={this.signUpUser}
          closeModal={this.closeModal}
          open={this.state.activeModal === "signup"}
          method={"signup"}
        />
        <LoginModal
          switchToSignup={() => this.setState({ activeModal: 'signup' })}
          signInWithGoogle={this.signIn}
          signInUser={this.signInUser}
          closeModal={this.closeModal}
          open={this.state.activeModal === "login"}
          method={"login"}
        />
        {/* <AcceptModal signOut={this.signOut}/> */}
          <NavBar
            user={this.props.user}
            handleSearch={this.handleSearch}
            searchString={this.state.searchString}
            clearSearchString={this.clearSearchString}
            signOut={this.signOut}
            signIn={this.signIn}

            logOut={this.logOut}
            logIn={this.logIn}
            signUp={this.signUp}
          />



          <Switch>
          <Route exact path="/" render={(props) => (
            <PublicEnvelopes {...props}
            mailbox="mine"
            user={this.props.user}
            searchString={this.state.searchString} /> )}/>

          <Route path="/myenvelopes" render={(props) => (
            <MyEnvelopes {...props}
            mailbox="mine"
            user={this.props.user}
            searchString={this.state.searchString} /> )}/>

          <Route path="/edit/:key" render={(props) => (
            <Edit {...props}
              signIn={() => this.setState({activeModal: 'login'})}
              user={this.props.user} /> )}/>

          <Route path="/new" render={(props) => (
            <Edit {...props}
              signIn={() => this.setState({activeModal: 'login'})}
              user={this.props.user} /> )}/>


          {/*
            <GalleryRoute user={this.props.user}
              authed={!!this.props.user} path='/myenvelopes'
              component={UserEnvelopes} showPublic={false}/>
          */}

              <Route  path="/envelopes" render={(props) => (
                  <PublicEnvelopes {...props}
                  mailbox="mine"
                  user={this.props.user}
                  searchString={this.state.searchString} /> )}/>

              {/* <Route exact path="/" render={(props) => (
                  <PublicEnvelopes {...props}
                  mailbox="mine"
                  user={this.props.user}
                searchString={this.state.searchString} /> )}/> */}


            {/* <Route path="/signup" component={Signup}/>
            <Route path="/login" component={Login}/> */}

            {/* <Route path="/about" component={About}/> */}
            <Route path="/about" render={(props) => (
              <About {...props} signUp={this.signUp} /> )}/>

            <Route path="/termsconditions" component={TermsAndConditions}/>
            <Route path="/privacypolicy" component={PrivacyPolicy}/>
            <Route path="/account" component={Account}/>
            <Route path="/create" render={(props) => (
              <Create {...props} user={this.props.user} /> )}/>
            <Route path="/run/:key" render={(props) => (
              <Run {...props} user={this.props.user} /> )}/>
            <Route path="/host/:key" render={(props) => (
              <Host {...props} user={this.props.user} /> )}/>
          </Switch>
          {/* <Footer /> */}

        </div>
      </Router>
    )
  }
}

export default App;


































// <Navbar>
// <Navbar.Header>
//   <Navbar.Brand>
//     <Link to="/" onClick={this.clearSearchString}>
//       <img src="/envelopeLogoRed.png" alt="ENVLOGO" height="40"/>
//       Envelope
//     </Link>
//   </Navbar.Brand>
// </Navbar.Header>
//   <div className="col-lg-6">
//     <div className="input-group navSearch">
//     <SearchBox query={this.state.searchString}
//       placeholder="Search"
//       type="text"
//       handleSearch={this.handleSearch} />
//       <span className="input-group-btn">
//         <button className="btn btn-default" type="button">
//           <Glyphicon glyph="search"></Glyphicon>
//         </button>
//       </span>
//     </div>
//   </div>
//
// <ul className="nav navbar-nav pull-right">
//   <li>
//     <Link to="/create">Create</Link>
//   </li>
//   <li>
//     <Link to="/about">About</Link>
//   </li>
//   {this.props.user ?
//     <li>
//       <Link to="/myenvelopes">My Envelopes</Link>
//     </li>
//      : null}
//   {LogInorOut}
// </ul>
// </Navbar>



// WEBPACK FOOTER //
// ./src/App.js